import { useState } from "react";
import { Row, Col, Button } from "react-bootstrap";
import Select from "react-select";
import { useSelector } from "react-redux";

import { validRoles } from "@/services/Utils";

import classes from "../maintainers.module.scss";
import { customStyles } from "./users.constants";

import { NoOptionsMessage } from "@/components/ReactSelect/NoOptions";

const UsersFilter = ({ filter, applyFilter }) => {
	const { customers, estates, estates_parents, roles } = useSelector((state) => state.maintainers_users);

	const { user } = useSelector((state) => state.auth);

	const [filterCustomer, setFilterCustomer] = useState(filter.customer_id);
	const [filterEstateParent, setFilterEstateParent] = useState(filter.filter_estate_parent_id);
	const [filterEstate, setFilterEstate] = useState(filter.filter_estate_id);
	const [filterRole, setFilterRole] = useState(filter.role_id);
	const userRoles = JSON.parse(localStorage.getItem("roles"));
	const isAdmin = validRoles(userRoles, ["administrador"]);

	const handleApplyFilter = () => {
		applyFilter({
			filterCustomer,
			filterEstateParent,
			filterEstate,
			filterRole,
		});
	};

	const handleCleanFilter = () => {
		applyFilter({
			filterCustomer: "",
			filterEstateParent: "",
			filterEstate: "",
			filterRole: "",
		});
	};

	return (
		<Col md={3} className={classes.filter}>
			<h4 className={classes.filterTitle}>Filtros</h4>
			<hr style={{ marginTop: "0.5em", marginBottom: "0.5em" }} />

			<div className={classes.divContent}>
				{isAdmin && (
					<Row className={classes.divForm}>
						<Col md={12} className={classes.divLabel}>
							<span className={classes.label}>Cliente</span>
						</Col>

						<Col md={12}>
							<Select
								value={customers.filter((c) => c.value === filterCustomer)}
								placeholder={<div>Seleccione</div>}
								options={customers ? customers : []}
								onChange={(value) => {
									setFilterEstateParent("");
									setFilterEstate("");
									setFilterCustomer(value.value);
								}}
								components={{
									NoOptionsMessage,
								}}
								menuPortalTarget={document.body}
								styles={customStyles}
							/>
						</Col>
					</Row>
				)}

				<Row className={classes.divForm}>
					<Col md={12} className={classes.divLabel}>
						<span className={classes.label}>Campo</span>
					</Col>

					<Col md={12}>
						<Select
							value={estates_parents.filter((estate_parent) => estate_parent.value === filterEstateParent)}
							placeholder={<div>Seleccione</div>}
							options={
								estates_parents
									? isAdmin && filterCustomer
										? estates_parents.filter((estate_parent) => estate_parent.customer_id === filterCustomer)
										: user && user.customer && estates_parents.filter((estate) => estate.customer_id === user.customer.id)
									: []
							}
							onChange={(value) => {
								setFilterEstateParent(value.value);
								setFilterEstate("");
							}}
							components={{
								NoOptionsMessage,
							}}
							menuPortalTarget={document.body}
							styles={customStyles}
						/>
					</Col>
				</Row>

				<Row className={classes.divForm}>
					<Col md={12} className={classes.divLabel}>
						<span className={classes.label}>Bodega</span>
					</Col>

					<Col md={12}>
						<Select
							value={estates.filter((estate) => estate.value === filterEstate)}
							placeholder={<div>Seleccione</div>}
							options={
								estates
									? isAdmin && filterCustomer
										? estates.filter((estate) => estate.customer_id === filterCustomer)
										: user && user.customer && estates.filter((estate) => estate.customer_id === user.customer.id)
									: []
							}
							onChange={(value) => {
								setFilterEstate(value.value);
							}}
							components={{
								NoOptionsMessage,
							}}
							menuPortalTarget={document.body}
							styles={customStyles}
						/>
					</Col>
				</Row>

				<Row className={classes.divForm}>
					<Col md={12} className={classes.divLabel}>
						<span className={classes.label}>Rol</span>
					</Col>

					<Col md={12}>
						<Select
							value={roles.filter((r) => r.value === filterRole)}
							placeholder={<div>Seleccione</div>}
							options={roles ? (isAdmin ? roles : roles.filter((r) => Number(r.value) !== 1)) : []}
							onChange={(value) => {
								setFilterRole(value.value);
							}}
							components={{
								NoOptionsMessage,
							}}
							menuPortalTarget={document.body}
							styles={customStyles}
						/>
					</Col>
				</Row>
			</div>

			<div className={classes.divFooter}>
				<Button className={classes.buttonClean} onClick={() => handleCleanFilter()}>
					Limpiar
				</Button>

				<Button className={classes.buttonApply} onClick={() => handleApplyFilter()}>
					Aplicar
				</Button>
			</div>
		</Col>
	);
};

export default UsersFilter;
